import { Bits } from './bits';

export enum OptimizePermissions {
	CanAccessOptimize = Bits.Bit1,
	OptimizeDelete = Bits.Bit2
}
